import type { IDashboardTemplate } from "../types";
import { EFamilyTypes } from "../components/DashboardTemplatesTypes";
import { AssetsService } from "../../../../services/AssetsService";

const dashboard: IDashboardTemplate = {
    id: 9,
    title: "dashboard.templates.socialmediatrafficmonitoring.title",
    description: "dashboard.templates.socialmediatrafficmonitoring.description",
    descriptionLong: "dashboard.templates.socialmediatrafficmonitoring.description.long",
    keyMetrics: "dashboard.templates.socialmediatrafficmonitoring.keymetric",
    previewImage: AssetsService.assetUrl("/images/dashboard/templates/SocialMediaTrafficMonitoring-preview.png"),
    thumbnailImage: AssetsService.assetUrl("/images/dashboard/templates/SocialMediaTrafficMonitoring-thumb.png"),
    familyType: EFamilyTypes.Website,
    autoFillUserDomain: true,
    minItems: 2,
    maxItems: 5,
    widgets: [
        {
            pos: {
                sizeX: 4,
                sizeY: 1,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 0,
                col: 0,
            },
            properties: {
                selectedChannel: "Social",
                metric: "ChannelsAnalysisByTrafficShare",
                webSource: "Desktop",
                duration: "28d",
                type: "MmxTrafficShareDashboard",
                filters: {
                    includeSubDomains: "true",
                    timeGranularity: "Daily",
                },
                width: "4",
                customAsset: false,
                family: "Website",
                options: {},
                title: "Social Traffic | Last 28 Days",
                tooltip: "Social Traffic.tooltip",
                titleTemplate: "custom",
            },
        },
        {
            pos: {
                sizeX: 4,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 1,
                col: 0,
                sizeY: 1,
            },
            properties: {
                flexibleDuration: true,
                duration: "6m",
                family: "Website",
                type: "MmxTrafficShareDashboard",
                webSource: "Desktop",
                metric: "ChannelsAnalysisByTrafficShare",
                selectedChannel: "Social",
                filters: {
                    includeSubDomains: true,
                    timeGranularity: "Monthly",
                },
                options: {},
                tooltip: "Traffic_Social.tooltip",
                title: "Social Traffic | Last 6 Months",
                titleTemplate: "custom",
            },
        },
        {
            pos: {
                sizeX: 2,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 2,
                col: 0,
                sizeY: 1,
            },
            properties: {
                flexibleDuration: true,
                duration: "6m",
                family: "Website",
                type: "MmxPagesPerVisitDashboard",
                webSource: "Desktop",
                metric: "ChannelsAnalysisByPagesPerVisit",
                selectedChannel: "Social",
                filters: {
                    includeSubDomains: true,
                    timeGranularity: "Monthly",
                },
                options: {},
                tooltip: "Page/Visit Social.tooltip",
                title: "Page/Visit - Social",
                titleTemplate: "custom",
            },
        },
        {
            pos: {
                sizeX: 2,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 2,
                col: 2,
                sizeY: 1,
            },
            properties: {
                flexibleDuration: true,
                duration: "6m",
                family: "Website",
                type: "MmxBounceRateDashboard",
                webSource: "Desktop",
                metric: "ChannelsAnalysisByBounceRate",
                selectedChannel: "Social",
                filters: {
                    includeSubDomains: true,
                    timeGranularity: "Monthly",
                },
                options: {},
                tooltip: "Bounce Rate Social.tooltip",
                title: "Bounce Rate - Social",
                titleTemplate: "custom",
            },
        },
        {
            pos: {
                sizeX: 2,
                sizeY: 2,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 3,
                col: 0,
            },
            properties: {
                selectedChannel: "Direct",
                metric: "TrafficSourcesSocial",
                webSource: "Desktop",
                duration: "1m",
                type: "Table",
                filters: {
                    orderBy: "TotalShare desc",
                    includeSubDomains: "true",
                    timeGranularity: "Daily",
                },
                width: "2",
                customAsset: false,
                family: "Website",
                options: {},
                title: "Social Referrers | Last Month",
                tooltip: "Social Traffic.tooltip",
                titleTemplate: "custom",
            },
        },
        {
            pos: {
                sizeX: 2,
                sizeY: 2,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 3,
                col: 2,
            },
            properties: {
                selectedChannel: "Direct",
                metric: "TrafficSourcesSocial",
                webSource: "Desktop",
                duration: "3m",
                type: "Table",
                filters: {
                    orderBy: "TotalShare desc",
                    includeSubDomains: "true",
                    timeGranularity: "Daily",
                },
                width: "2",
                customAsset: false,
                options: {},
                family: "Website",
                title: "Social Referrers | Last 3 Months",
                tooltip: "Social Traffic.tooltip",
                titleTemplate: "custom",
            },
        },
    ],
};
export default dashboard;
